module.exports = __webpack_public_path__ + "img/icon-device.01a37c0d.svg";